import {useIsFetching} from 'react-query';
export const useQueriesLoading = (queryKeys: string[]) => {
    const isFetching = useIsFetching({
        queryKey: queryKeys,
    });

    return isFetching > 0;
};
